import React, { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';

import { PAGE_CONTENT_CLASS } from '../../components/layout/PageContent';
import PageHeader from '../../components/PageHeader';
import Input from '../../components/ui/Input';
import Select from '../../components/ui/Select';
import {
  getCategorySelectOptions,
  getSystemModels,
  getSystemModelsByCategory,
} from '../../data/systemModels';
import { FavoriteModelsProvider } from '../../context/FavoriteModelsContext';
import SystemModelCard from './components/SystemModelCard';

const SystemModelsPage = () => {
  const categoryOptions = useMemo(() => getCategorySelectOptions(), []);
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const filteredModels = useMemo(() => {
    const base = selectedCategory
      ? getSystemModelsByCategory(selectedCategory)
      : getSystemModels();
    const query = search.trim().toLowerCase();
    if (!query) return base;
    return base.filter((model) => model.name.toLowerCase().includes(query));
  }, [search, selectedCategory]);

  return (
    <>
      <Helmet>
        <title>Modelos do Sistema</title>
        <meta
          name="description"
          content="Catálogo completo de modelos do sistema por categoria"
        />
      </Helmet>

      <div className={PAGE_CONTENT_CLASS}>
        <PageHeader
          title="Modelos do Sistema"
          subtitle="Todos os modelos disponíveis organizados por categoria profissional"
          icon="FileText"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 md:mb-8">
          <Input
            label="Buscar modelo"
            placeholder="Filtrar por nome..."
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <Select
            label="Categoria"
            placeholder="Todas as categorias"
            options={categoryOptions}
            value={selectedCategory}
            onChange={setSelectedCategory}
            clearable
          />
        </div>

        <FavoriteModelsProvider>
          {filteredModels.length === 0 ? (
            <p className="text-sm text-muted-foreground text-center py-16">
              Nenhum modelo encontrado com os filtros selecionados.
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredModels.map((model) => (
                <SystemModelCard key={model.id} model={model} />
              ))}
            </div>
          )}
        </FavoriteModelsProvider>
      </div>
    </>
  );
};

export default SystemModelsPage;
